import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
const Footer = () => {
  const data = [
    {
      label: "My Account",
      link: "/my-account",
    },
    {
      label: "Privacy Agreement",
      link: "/privacy-agreement",
    },
    {
      label: "Risk Disclosure",
      link: "/risk-disclosure",
    },
    {
      label: "Complaints Handling Policy",
      link: "/complaints-handling-policy",
    },
    {
      label: "Legal documents",
      link: "/legal-documents",
    },
    {
      label: "Security instructions",
      link: "/security-instructions",
    },
    {
      label: "Preventing Money Laundering",
      link: "/preventing-money-laundering",
    },
  ];

  return (
    <>
      <section className="Footer">
        <div className="page_links_div">
          {data?.map((item) => {
            return (
              <Link to={item?.link} className="footer-link">
                <p className="link_text">{item?.label}</p>
              </Link>
            );
          })}
        </div>
        {/* <p className="right_text">© 2025 All Rights Reserved by Profcyma</p> */}
      </section>
    </>
  );
};

export default Footer;
